// Boards: LangGlobe, LangGlobeOpen, LangEnGuest, LangEnGuestOpen (the globe in the top corner of the guest home and
// sign-in, and its open menu); the round 1 top bars (my decks, deck editor, account). The account menu's language row
// (SignedInHome) opens the same list.
import React, { useEffect, useRef, useState } from 'react';
import { languages, setLanguage, t } from '../../i18n';
import { Bdi } from '../../i18n/direction';
import { GlobeIcon, onTap } from './parts';

const CORNER = { position: 'absolute', top: 12, insetInlineEnd: 16 };

const CheckIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 13l4 4 10-10"></path></svg>
);

// The open menu. It closes on a selection, on Escape and on a press outside it and outside `trigger` (whose own
// click toggles it); the caller puts the focus back.
export function LanguageList({ trigger, onClose }) {
  const list = useRef(null);

  // Keyboard focus goes into the list (from the account menu, the row that opened it is gone).
  useEffect(() => list.current.querySelector('[aria-checked="true"]').focus(), []);

  useEffect(() => {
    const onKey = e => e.key === 'Escape' && onClose();
    const onPress = e => !list.current.contains(e.target) && !trigger?.current?.contains(e.target) && onClose();
    document.addEventListener('keydown', onKey);
    document.addEventListener('pointerdown', onPress);
    return () => {
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('pointerdown', onPress);
    };
  }, [trigger, onClose]);

  const choose = code => {
    setLanguage(code);
    onClose();
  };

  return (
    <div ref={list} className="menu" role="menu" aria-label={t('language.label')} style={{ width: 180 }}>
      {languages().map(({ code, name, current }) => (
        <a key={code} className="menu-item" role="menuitemradio" aria-checked={current ? 'true' : 'false'} href={`#${code}`}
          onClick={onTap(() => choose(code))}>
          <span style={{ flex: 1 }}><Bdi lang={code}>{name}</Bdi></span>{current && <CheckIcon />}
        </a>
      ))}
    </div>
  );
}

// The globe and its menu. `corner` places the globe in the top corner of a screen with no top bar.
export default function LanguageMenu({ corner }) {
  const [open, setOpen] = useState(false);
  const globe = useRef(null);
  const close = () => {
    setOpen(false);
    globe.current.focus();
  };
  return (
    <>
      <a ref={globe} className="icon-btn" href="#language" onClick={onTap(() => setOpen(o => !o))}
        aria-label={t('language.current', { name: t('language.name') })} aria-haspopup="menu" aria-expanded={open ? 'true' : 'false'}
        style={{ ...(corner ? CORNER : {}), border: '2px solid #24102a', borderRadius: 999, ...(open ? { background: '#7fe0b5' } : {}) }}>
        <GlobeIcon size="22" />
      </a>
      {open && <LanguageList trigger={globe} onClose={close} />}
    </>
  );
}
